import { withCreateFireUIAnalytics } from 'view/common/analytics/with-create-fire-ui-analytics';
import type { Props } from './search-bar';
import SearchBar from './search-bar';

export default withCreateFireUIAnalytics<Props>('searchBar', {
    onFocus: () => ({ action: 'focused' }),
    onSubmit: () => ({ action: 'submitted' }),
})(SearchBar);
